// Routed pages render a shell (DetailPage/Page/NewPage) instead of composing
// Paper directly — see src/components/layout/AGENTS.md.
import { ReactNode } from "react";

import { BoxProps, Column, PaddingProps } from "@hightouch/htui";

import { PageSuspense } from "src/components/loading";

export const PAPER_RIGHT_PADDING = 2;
export const PAPER_RIGHT_PADDING_PX = PAPER_RIGHT_PADDING * 4;

export const Paper = ({
  header,
  children,
  // If the paper is nested within another paper, we need to adjust the padding.
  isNested = false,
  ...props
}: { header?: ReactNode; isNested?: boolean } & Omit<
  BoxProps,
  keyof PaddingProps
>) => {
  return (
    <Column
      gap={2}
      pb={0}
      pl={isNested ? 2 : 0.5}
      pr={PAPER_RIGHT_PADDING}
      pt={2}
      minWidth={0}
      // Scope for useIdle in editor-overlay.tsx — events outside Paper
      // (e.g. global nav clicks) don't reset the idle timer.
      data-idle-scope
      {...props}
    >
      {header}
      <Column
        bg="white"
        borderTopRadius="2xl"
        boxShadow="sm"
        flex={1}
        minHeight={0}
        overflow="clip"
      >
        <PageSuspense>{children}</PageSuspense>
      </Column>
    </Column>
  );
};
